import { render, staticRenderFns } from "./gestionJuridico.vue?vue&type=template&id=2b72d797"
import script from "./gestionJuridico.vue?vue&type=script&lang=js"
export * from "./gestionJuridico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports